// Newsletter popup

document.addEventListener("DOMContentLoaded", function () {
  const popupBtn = document.querySelector(".newsletter-popup-button");
  const closeBtn = document.querySelector(".newsletter-popup-container .close-popup-btn");
  const overlay = document.querySelector(".newsletter-popup-overlay.newsletter-popup-container");

  if (popupBtn && overlay) {

    setTimeout(() => {
      overlay.classList.add("active");
    },5000);

    popupBtn.addEventListener("click", function () {
      overlay.classList.add("active");
    });
  }

  if (closeBtn && overlay) {
    closeBtn.addEventListener("click", function () {
      overlay.classList.remove("active");
    });
  }

  const memberPopupBtns = document.querySelectorAll(".open-signup-popup");
  const memberCloseBtn = document.querySelector(".custom-fit-signup-popup .close-popup-btn");
  const memberOverlay = document.querySelector(".custom-fit-signup-popup");

  if (memberOverlay) {
    memberPopupBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        memberOverlay.classList.add("active");
      });
    });

    if (memberCloseBtn) {
      memberCloseBtn.addEventListener("click", function () {
        memberOverlay.classList.remove("active");
      });
    }
  }
});


//Submenu animation

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.menu-drawer__menu-item.list-menu__item').forEach(item => {
    const submenu = item.nextElementSibling;
    if (!submenu || !submenu.classList.contains('menu-drawer__submenu')) return;

    let timer;

    const open = () => {
      clearTimeout(timer);
      document.querySelectorAll('.menu-drawer__submenu.open').forEach(el => {
        if (el !== submenu) {
          el.classList.remove('open');
          el.previousElementSibling?.classList.remove('open');
        }
      });
      submenu.classList.add('open');
      item.classList.add('open');
    };

    const close = () => {
      timer = setTimeout(() => {
        submenu.classList.remove('open');
        item.classList.remove('open');
      }, 200);
    };

    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', close);
    submenu.addEventListener('mouseenter', () => clearTimeout(timer));
    submenu.addEventListener('mouseleave', close);
  });
});

//footer menu mobile  accordion

document.addEventListener('DOMContentLoaded', function () {
  const toggles = document.querySelectorAll('.accordion-toggle');

  toggles.forEach(toggle => {
    toggle.addEventListener('click', function () {
      const contentWrapper = this.nextElementSibling;

      toggles.forEach(otherToggle => {
        const otherContent = otherToggle.nextElementSibling;

        if (otherToggle !== this) {
          otherToggle.classList.remove('active');
          otherContent.classList.remove('open');
        }
      });

      this.classList.toggle('active');
      contentWrapper.classList.toggle('open');
    });
  });
});

//Header color logic

document.addEventListener('DOMContentLoaded', function () {
  const headerColorControl = document.getElementById('header-color-control');
  const header = document.querySelector('.header-wrapper');

  if (headerColorControl && header) {
    const scheme = headerColorControl.dataset.headerColorScheme;
    if (scheme) {
      header.classList.add(scheme); 
    }
  }
});

//Gallery animation

document.addEventListener('DOMContentLoaded', function () {
  const cards = document.querySelectorAll('.gallery-card');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.1
  });

  cards.forEach(card => observer.observe(card));
});

// Product page function



document.addEventListener('DOMContentLoaded', function () {
  const svgWrappers = document.querySelectorAll('.product__info-wrapper__action .svg-wrapper');

  svgWrappers.forEach(function (svgWrapper) {
    svgWrapper.addEventListener('click', function () {
      const actionWrapper = svgWrapper.closest('.product__info-wrapper__action');
      const parentActionWrapper = svgWrapper.closest('.product__info-wrapper');

      if (actionWrapper && parentActionWrapper) {
        parentActionWrapper.classList.toggle('animate-hide');
        actionWrapper.classList.toggle('hide');
      }
    });
  });
});



document.addEventListener('DOMContentLoaded', function () {
  const readMoreBtn = document.querySelector('.read-more-button');
  const truncated = document.querySelector('.truncated-description');
  const full = document.querySelector('.full-description');

  if (readMoreBtn && truncated && full) {
    readMoreBtn.addEventListener('click', function () {
      truncated.style.display = 'none';
      full.classList.remove('hidden');
      readMoreBtn.style.display = 'none';
    });
  }
});

document.querySelectorAll('.product_inner_accordion .summary__title').forEach(header => {
  header.addEventListener('click', function () {
    const parent = this.parentElement;
    const isActive = parent.classList.contains('active');

    document.querySelectorAll('.product_inner_accordion').forEach(acc => {
      acc.classList.remove('active');
      acc.querySelector('.accordion_content').style.maxHeight = null;
    });

    if (!isActive) {
      parent.classList.add('active');
      const content = parent.querySelector('.accordion_content');
      content.style.maxHeight = content.scrollHeight + "px";
    }
  });
});


document.addEventListener('DOMContentLoaded', function () {
  let previousVariantId = null;

  const productMediaList = document.querySelector('.product__media-list');

  // All known color keywords to detect from variant option labels
  const colorKeywords = ['black', 'white', 'red', 'blue', 'green', 'pink', 'grey', 'gray', 'navy', 'beige', 'brown', 'yellow', 'dune' , 'aquadive', 'ember'];

  function getColorFromVariantLabel() {
    // Try to find the selected color option from Shopify's variant selectors
    // Method 1: variant-radios / variant-selects web components
    const variantRadios = document.querySelectorAll('variant-radios input:checked, variant-selects option:checked, .variant__input--color input:checked');
    for (const el of variantRadios) {
      const label = (el.value || el.dataset.value || el.getAttribute('aria-label') || '').toLowerCase();
      const matched = colorKeywords.find(c => label.includes(c));
      if (matched) return matched;
    }

    // Method 2: read from the selected option text in a <select>
    const selects = document.querySelectorAll('select[name*="Color"], select[name*="color"], select[id*="color"]');
    for (const select of selects) {
      const label = (select.options[select.selectedIndex]?.text || '').toLowerCase();
      const matched = colorKeywords.find(c => label.includes(c));
      if (matched) return matched;
    }

    // Method 3: read active swatch button label
    const activeSwatches = document.querySelectorAll('.swatch--active, .color-swatch.active, [data-value].is-active, input[type="radio"]:checked');
    for (const el of activeSwatches) {
      const label = (el.value || el.dataset.value || el.getAttribute('aria-label') || el.title || '').toLowerCase();
      const matched = colorKeywords.find(c => label.includes(c));
      if (matched) return matched;
    }

    // Method 4: fallback — parse the variant title from the page JSON
    const variantId = String(new URLSearchParams(window.location.search).get('variant'));
    if (variantId && window.ShopifyAnalytics?.meta?.selectedVariantId) {
      // no-op — handled below
    }

    return null;
  }

  function getColorFromPageMeta(variantId) {
    // Shopify exposes product JSON — try to find the variant title
    const productJson = document.querySelector('[data-product-json], script[type="application/json"][id*="product"]');
    if (productJson) {
      try {
        const data = JSON.parse(productJson.textContent);
        const variant = (data.variants || []).find(v => String(v.id) === variantId);
        if (variant) {
          const title = (variant.title || variant.option1 || variant.option2 || '').toLowerCase();
          const matched = colorKeywords.find(c => title.includes(c));
          if (matched) return matched;
        }
      } catch (e) {}
    }
    return null;
  }

  function updateClassFromVariant() {
    const variantId = String(new URLSearchParams(window.location.search).get('variant'));

    if (!variantId || variantId === previousVariantId || !productMediaList) return;

    // Detect color
    let color = getColorFromVariantLabel() || getColorFromPageMeta(variantId);

    // Remove all previous color classes
    productMediaList.classList.remove(...colorKeywords);

    if (color) {
      productMediaList.classList.add(color);
      console.log(`Variant ${variantId} → class: "${color}"`);
    } else {
      console.log('No color match for variantId:', variantId);
    }

    previousVariantId = variantId;
  }

  updateClassFromVariant();
  setInterval(updateClassFromVariant, 500);
});

document.addEventListener('DOMContentLoaded', function () {
  const input = document.getElementById('personalized-text');

  if (input){
    input.addEventListener('input', function () {
      // Allow only letters and space
      this.value = this.value.replace(/[^A-Za-z ]/g, '');

      // Limit to 10 characters
      if (this.value.length > 10) {
        this.value = this.value.slice(0, 10);
      }
    });
  }
});

